import { createSelector } from '@reduxjs/toolkit';

export const selectCartSummaryPrices = (state) => {
  const orderView = state?.cartDetails?.cartDetailsJson?.orderDetailsView;
  const checkoutOrder = state?.checkout?.orderDetails;

  return {
    today: orderView?.dueTodayAmount ?? checkoutOrder?.totalDueToday ?? 0,
    monthly: orderView?.dueMonthlyAmount ?? checkoutOrder?.totalMonthlyDue ?? 0,
    savings: orderView?.dueMonthlyDiscountAmount ?? checkoutOrder?.dueMonthlyDiscountAmount ?? 0,
  };
};

export const selectCartBuckets = createSelector(
  [selectCartSummaryPrices],
  (prices) => {
    const buckets = [];

    const todayValue = Number(prices.today);
    if (todayValue > 0) {
      buckets.push({
        id: 'due-today',
        label: 'Due today',
        value: todayValue,
        isSavings: false,
        suffix: '',
      });
    }

    const monthlyValue = Number(prices.monthly);
    if (monthlyValue > 0) {
      buckets.push({
        id: 'est-monthly',
        label: 'Est monthly',
        value: monthlyValue,
        isSavings: false,
        suffix: '',
      });
    }

    const savingsValue = Number(prices.savings);
    if (savingsValue > 0) {
      buckets.push({
        id: 'savings',
        label: 'Savings',
        value: savingsValue,
        isSavings: true,
        suffix: '/mo',
      });
    }

    return buckets;
  }
);

export const hasCartSummaryData = ({ today = 0, monthly = 0, savings = 0 } = {}) =>
  Number(today) > 0 || Number(monthly) > 0 || Number(savings) > 0;

export const selectHasCartSummaryData = (state) => hasCartSummaryData(selectCartSummaryPrices(state));

export const hasValidPlanItem = (items = []) =>
  Array.isArray(items) &&
  items
    .filter((item) => (item?.itemType || item?.cartItemType)?.toUpperCase() === 'PLAN')
    .some((item) => (item?.itemName || item?.name || '').trim());

export const selectHasValidPlan = (state) => {
  const dueMonthlyList = state?.cartDetails?.cartDetailsJson?.dueMonthlyList;
  const items = Array.isArray(dueMonthlyList) ? dueMonthlyList : [];

  return hasValidPlanItem(items);
};
